import { IOrganization } from "../../../store/slice/listClientForAgentSlice/listClientForAgentSlice";

export function isIOrganization(obj: any): obj is IOrganization {
  return (
    obj &&
    typeof obj === "object" &&
    typeof obj.id === "number" &&
    (typeof obj.inn === "string" || obj.inn === null) &&
    typeof obj.ogrn === "string" &&
    typeof obj.name === "string" &&
    (typeof obj.phone_number === "string" || obj.phone_number === null) &&
    (typeof obj.email === "string" || obj.email === null) &&
    (typeof obj.snils === "string" || obj.snils === null) &&
    typeof obj.created_at === "string" &&
    typeof obj.updated_at === "string"
  );
}
